<template>
  <basic-dialog :visible="visible"
                :title="title"
                :width="600"
                :update-vis="updateVis"
                :handle-close="handleClose"
                :handle-closed="handleClosed"
                :handle-ok="handleOk"
                >

    <el-form ref="form"
             size="small"
             label-position="right"
             label-width="128px"
             :model="dto"
             :rules="rules"
             @submit.native.prevent>
      <div class="entity-dlg__block">
        <div class="entity-dlg__block-bd">
          <el-row :gutter="24">
            <el-col :span="20"
                    :offset="1">
              <el-form-item :label="$t('language.5o6upp1vp920')"
                            prop="groupCode">
                <el-input v-model.trim="dto.groupCode"
                          :placeholder="$t('language.5o6u3f6cnok0')"
                          :disabled="!!dto.id" />
              </el-form-item>
            </el-col>
            <el-col :span="20"
                    :offset="1">
              <el-form-item :label="$t('language.5o6upp1vp930')"
                            prop="groupName">
                <el-input v-model.trim="dto.groupName"
                          :placeholder="$t('language.5o6u3f6cnok0')" />
              </el-form-item>
            </el-col>

            <el-col :span="20"
                    :offset="1">
              <el-form-item :label="$t('language.5o6otz4p1w00')"
                            prop="remark">
                <el-input v-model="dto.remark"
                          type="input"
                          :placeholder="$t('language.5o6u3f5cnok0')" />
              </el-form-item>

            </el-col>
          </el-row>
            <el-row :gutter="24">
                <el-col :span="20" :offset="1" v-for="item in state.extList" :key="item.key">
                    <el-form-item :label="item.name" :prop="item.key" :rules="item.rules">
                        <el-input v-if="item.type === 'input'" v-model.trim="dto[item.key]"
                                  :placeholder="item.placeholder" clearable/>
                        <el-input v-else-if="item.type === 'textarea'" type="textarea" v-model.trim="dto[item.key]"
                                  :placeholder="item.placeholder" clearable/>
                        <el-select v-else-if="item.type === 'select'" v-model.trim="dto[item.key]"
                                   :placeholder="item.placeholder" clearable filterable>
                            <el-option v-for="subItem of item.options" :key="subItem.code" :label="subItem.label"
                                       :value="subItem.value"/>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
        </div>
      </div>
    </el-form>
  </basic-dialog>
</template>

<script>
// 添加或编辑用户
import EntityDialog from '@/mixins/entityDialog'
import { mapState } from 'vuex'
export default {
  mixins: [EntityDialog],

  props: {
    state: {
      type: Object,
      default() {
        return {}
      }
    },
    selectItem: {
      type: Object,
      default() {
        return {}
      }
    },
    treeOrgList: {
      type: Array,
      default() {
        return []
      }
    },
    winClose: {
      type: Function,
      default() {
        return () => { }
      }
    }
  },
  data() {
    return {
      rules: {
        groupCode: [
          { required: true, message: this.$t('language.5o6uyb93vi20'), trigger: 'blur' },
          { pattern: CNST.REG_EXP.ENGNUMLINEREDUCEZHPOINT, message: this.$t('language.5o6umqna9yk0')},
          { max: 80, message: this.$t('language.5o6uqqna9yk0'), trigger: ['change','blur'] },
        ],
        groupName: [
          { required: true, message: this.$t('language.5o6uyb93vi30'), trigger: 'blur' },
          { max: 80, message: this.$t('language.5o61qqna9yk0'), trigger: ['change','blur'] },
        ],
        remark: [
          { max: 120, message: this.$t('language.5o6u3fr8nok0'), trigger: 'change' },
        ],
      },
      typeFlag: false,
      systype: []
    }
  },
  beforeCreate() {
    this.allFields = ['id', 'groupCode', 'groupName', 'remark',, 'ext1', 'ext2', 'ext3', 'ext4', 'ext5', 'ext6', 'ext7', 'ext8', 'ext9', 'ext10','ext11','ext12','ext13', 'ext14', 'ext15', 'ext16', 'ext17', 'ext18', 'ext19', 'ext20',]
    this.disFields = ['userCode']
  },
  watch: {

  },
  mounted() {

  },
  methods: {
    // 确定按钮
    handleOk() {
      this.$refs.form.validate(valid => {
        if (!valid) {
          return
        }
        let params = this.toEnd()
        this.handleSave({ params })
      })
    },
    // 关闭和取消按钮
    handleClose(ev) {
      console.log('handleClose:', ev)
      this.updateState('entity')
      if (this.$refs.form) {
        this.$nextTick(() => {
          this.$refs.form.clearValidate()
        })
      }
      this.winClose(ev)
    },
  }
}
</script>

